export const REQUIRED_REVIEW_COUNT = 5;
